export const DPO_CONSTANT = {

    // API endpoints
    API_ENDPOINT: '',
    TOKEN_VALIDATE_INTERVAL: 0,
    PAGE_COUNT:0,

    // Configs
    I18N_ENDPOINT: '/assets/i18n',
    CONFIG_ENDPOINT: '/assets/config/config.json',

    // Urls
    CONSULTATION_SEARCH: '/consultation/search',
    CONSULTATION_SUBSCRIBED_STATUS: '/consultation/subscribedStatus',
    CONSULTATION_DETAILS: '/consultation/details',
    CONSULTATION_RRDI_AUTOCOMPLETE: '/consultation/autosuggest',
    SUBSCRIPTION_RRDI_SEARCH: '/subscription/rrdisearch',
    SUBSCRIPTION_CURRENT: '/subscription/currentsubscription',
    SUBSCRIPTION_WARRANTY_CAMPAIGN_INFO: '/subscription/getwarrantrycompaignscinfo',
    SUBSCRIPTION_FEATURES: '/subscription/getSubscriptions',
    SUBSCRIPTION_SAVE: '/subscription/savesubscriptions',
    SUBSCRIPTION_DELEGATION: '/subscription/check-delegation',
    AUTHENTICATE_LOGIN: '/authUser/authenticateUser',
    AUTHENTICATE_TOKEN: '/authUser/authenticateDecodeUser',
    VALIDATE_TOKEN: '/validate/jwt-token',
    LANGUAGES: '/language/all',
    ISALIVE: '/connection/isAliveDPO.html',    //new parameter for isAlive Path

    // Date Format
    DATE_FROMAT: 'dd-MM-yyyy',

    // i18n Default
    DEFAULT_LOCALE: 'fr-FR',

    //Cache Keys
    CACHE_I18N_LOCALE: 'i18n_locale',
    CACHE_I18N_DATA: 'i18n_data',
    CACHE_USER_ID: 'user_id',
    CACHE_USER_ROLE: 'user_role',
    CACHE_USER_ROLES: 'user_roles',
    CACHE_APPLICATION_NAME: 'applicationName',      // Cap-20753 : Initialising constant applicationName 
    CACHE_USER_TYPE: 'userType',        	        // Cap-20753 : Initialising constant userType
    CACHE_COUNTRY: 'country',                       // CAP-26096 : Added country
    CACHE_ACCESS_PATH: 'access_path',
    CACHE_QUERY_PARAMS: 'query_params',
    CACHE_IS_VALID_USER: 'is_valid_user',
    CACHE_IS_VALID_ROLE: 'is_valid_role',
    CACHE_DPO_CONSTANT: 'dpo_constant',
    CACHE_DPO_LANG: 'dpo_language',
    CACHE_PAGE_FLAG: 'dpo_page',
    CACHE_APP_NAME: 'dop_app_name',                     // DAAS-49 : Declared a key for appName
    CACHE_IAMSTRING: 'iAmString',                       //CAP-20753: Initializing constant iamString
    CACHE_RRDI_CODE: 'rrdi_code',                	//CAP-20753: Initializing constant rrdi_code
    CACHE_BASEAUTH: 'baseauth',                	 	//CAP_20753:PART-2: POI BASEAUTH - Initialializing constant baseauth

    //Export file name
    CONSULTATION_EXPORT_FILENAME: 'Portfolio_Consultation',
    OPERATION_EXPORT_FILENAME: 'Portfolio_Consultation_Operation',
    EXCEL_FILE_EXTENSION: '.xlsx',
    CSV_FILE_EXTENSION: '.csv',

    //Routing path.
    PATH_SUBSCRIPTION: 'subscription',
    PATH_CONSULTATION: 'consultation',
    PATH_ISALIVE: 'isAliveDPO.html',
    PATH_SUBSCRIPTIONVALIDATED: 'subscription-validated',         // CAP-26096_POUDG-8493: Lot-2 related changes

    //User's Role; CAP-26096: Added four roles barnd with country wise consult SA
    ROLE_PORT_CCS_USER: 'DPO.PORT_CCS_USER',
    ROLE_PORT_CCS_MANAGER: 'DPO.PORT_CCS_MANAGER',
    ROLE_PORT_TECH_USER: 'DPO.PORT_TECH_USER',
    ROLE_PORT_ADMIN: 'DPO.PORT_ADMIN',
    ROLE_PORT_CONSULT_AP: 'DPO.PORT_CONSULT_AP',
    ROLE_PORT_CONSULT_AC: 'DPO.PORT_CONSULT_AC',
    ROLE_PORT_CONSULT_DS: 'DPO.PORT_CONSULT_DS',
    ROLE_PORT_CONSULT_OV: 'DPO.PORT_CONSULT_OV',
    ROLE_PORT_CONSULT_AP_CC: 'DPO.PORT_CONSULT_AP_',
    ROLE_PORT_CONSULT_AC_CC: 'DPO.PORT_CONSULT_AC_',
    ROLE_PORT_CONSULT_DS_CC: 'DPO.PORT_CONSULT_DS_',
    ROLE_PORT_CONSULT_OV_CC: 'DPO.PORT_CONSULT_OV_',
    ROLE_PORT_GEODIAG: 'DPO.PORT_GEODIAG',

    //Query Params
    QP_TOKEN: 'token',
    QP_RRDI_CODE: 'rrdi_code',
    QP_VIN: 'vin',
    QP_RRDI_BRAND: 'rrdi_brand',
    QP_VIN_BRAND: 'vin_brand',
    QP_MILEAGE: 'mileage',
    QP_FOLDER_ID: 'folder_id',
    QP_CALLBACK_URL: 'callback_url',
    QP_LANGUAGE_ID: 'language_id',
    QP_CAMPAIGN: 'campaign',
    QP_WARRANTY_END_DATE: 'warranty_end_date',
    QP_APPLICATION_NAME: 'applicationName',     			//CAP-20753 : Added constant  QP_APPLICATION_NAME
    QP_USERID: 'userId',        		        		//CAP-20753 : Added constant  QP_USERID
    QP_USERTYPE: 'userType',        		    			//CAP-20753 : Added constant  QP_USERTYPE
    QP_IAMSTRING: 'iAmString',                          		//CAP-20753: Added Constant QP_IAMSTRING
    //Genral Constant
    YES: 'Yes',
    NO: 'No',
    NA: 'NA',   				                 	//CAP-20753 : Added constant NA
    POI: 'poi',                                  		 	//Cap-20753 : Added constant 
    DDC: 'ddc',                                   		 	//Cap-20753 : Added constant 
    HUB: 'hub',                                  		 	//Cap-20753 : Added constant 
    PNR: 'pnr',                                  		 	//Cap-20753 : Added constant 
    SUBSCRIPTION: 'subscription',                		 	//Cap-20753 : Added constant 
    CONSULTATION: 'consultation',               		 	//Cap-20753 : Added constant 
    LANGUAGES_PATH: '/assets/config/languages.json',   	 	//Cap-20753 : Added constant
    SUBSCRIBEDSTATUS_PATH: '/assets/config/subscribedStatus.json'	//Cap-20753 : Added constant
};
